<app-lang-switch position="absolute"></app-lang-switch>
<div class="container flex">
  <div [formGroup]="form" class="widget loginFormContainer p-6 flex flex-column gap-4">
    <img src="assets/images/logo.png" alt="Logo" class="appLogo" />
    <span class="text-center">{{ "auth.activation.title" | translate }}</span>
    <div class="flex flex-column gap-2 mb-3">
      <label for="username" class="font-semibold">{{ "auth.activation.username" | translate }}</label>
      <input pInputText id="username" formControlName="username" autocomplete="off" (keyup)="onKeyUp($event)" />
    </div>
    <!-- <div class="flex gap-2 mb-3 g-col-1-3">
      <label for="termsAndConditionsAccepted">
        {{ "auth.activation.accept_terms.accept" | translate }}
        <a href="https://botevo.com" target="_blank">
          {{
            "auth.activation.accept_terms.terms_and_conditions" | translate
          }}</a
        >
        {{ "auth.activation.accept_terms.and" | translate }}
        <a href="https://botevo.com" target="_blank">
          {{ "auth.activation.accept_terms.licence_terms" | translate }}</a
        >
      </label>
      <p-checkbox
        formControlName="termsAndConditionsAccepted"
        [binary]="true"
        inputId="termsAndConditionsAccepted"
      />
    </div> -->
    <app-button
      (click)="activate()"
      buttonText="auth.activation.activation_button"
      [block]="true"
      [disabled]="!form.valid"
    ></app-button>
  </div>
</div>
